import { AxiosResponse } from "axios";
import { api } from "../base/api";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { ReportTemplateGridResponse, ReportTemplateResponse } from "@/main/models/response";
import { IReportTemplateApi } from "../base/registration/reportTemplateApi";
import { ReportTemplateFilterRequest, ReportTemplateRequest, ReportTemplateDomainRequest } from "@/main/models/request";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

const baseRoute: string = "ReportTemplate";

export class ReportTemplateApi extends IReportTemplateApi {
	getReportTemplate(guidTemplate: string): Promise<AxiosResponse<Result<ReportTemplateResponse>>> {
		return api.get(`${baseRoute}`, { params: { guid: guidTemplate } });
	}

	getReportTemplateGrid(
		request: ReportTemplateFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<ReportTemplateGridResponse>>> {
		return api.get(`${baseRoute}/searchGrid`, { params: request });
	}

	getDocVariables(file: File): Promise<AxiosResponse<Result<string[]>>> {
		const formData = new FormData();
		formData.append("formFile", file);
		return api.post(`${baseRoute}/getdocvariables`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	getReportVariableTypeDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/getreportvariabletypedomain`);
	}

	save(request: ReportTemplateRequest, formFile: File): Promise<AxiosResponse<Result<string>>> {
		const formData = new FormData();
		Object.entries(request).forEach(([key, value]) => {
			formData.append(key, value);
		});
		formData.delete("variables");
		request.variables.forEach((variable, index) => {
			Object.entries(variable).forEach(([key, value]) => {
				formData.append(`variables[${index}].${key}`, value);
			});
		});
		if (formFile) {
			formData.append("formFile", formFile);
		}
		return api.post(`${baseRoute}/save`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	getDomain(request: ReportTemplateDomainRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}
}
